import { numberWithCommas } from '~/js/helpers'

export default class Product {
  constructor(product = {}) {
    this.available =
      product.available === undefined ? undefined : product.available
    this.categoryHandles = product.category_handles
    this.categoryTitles = product.category_titles
    this.comparePrice = product.compare_at_price
      ? product.compare_at_price / 100
      : undefined
    this.comparePriceMin =
      product.type && product.type.includes('オーダーカーテン') // 要確認
        ? null
        : product.compare_at_price_min
        ? product.compare_at_price_min / 100
        : undefined
    this.features = []
    this.handle = product.handle
    this.id = product.id
    this.price = product.price ? product.price / 100 : undefined
    this.priceMin = product.price_min ? product.price_min / 100 : undefined
    this.productImage = product.featured_image || ''
    this.productType = product.type || ''
    this.sku = product.sku
    this.stock = product.inventory_quantity
    this.tags = product.tags || []
    this.text1 = this.getFieldByTag('商品名追加テキスト1')
    this.text2 = this.getFieldByTag('商品名追加テキスト2')
    this.title = product.title
    this.url = product.url || `/products/${this.handle}`
    this.variants = product.variants || []
    this.variantId = this.variants.length && this.variants[0].id
    this.vendor = product.vendor

    this.color = this.getFieldByTag('カラー')
    this.seriesName = this.getFieldByTag('series_name')
    this.alternateTitle = this.getFieldByTag('alternate_title')
    this.lead = this.getFieldByTag('lead')
    this.itemGroupId = this.getFieldByTag('item_group_id')
  }

  getFieldByTag(tagPrefix) {
    const targetTag = this.tags.find((tag) => tag.includes(`${tagPrefix}:`))
    return targetTag ? targetTag.replace(`${tagPrefix}:`, '') : ''
  }

  get discountPercentage() {
    return Math.floor(
      ((this.comparePrice - this.price) * 100) / this.comparePrice
    )
  }

  get imageUrl() {
    return (
      this.productImage || "{{ 'no_image_b.jpg' | asset_img_url:'medium' }}"
    )
  }

  get isActionAvailable() {
    return (
      (this.productStatus === 'available' ||
        this.productStatus === 'presale') &&
      !this.productType.includes('オーダーカーテン')
    )
  }

  get isHandleValid() {
    return /^\d{13}$/.test(this.handle)
  }

  get isSale() {
    return (
      this.comparePriceMin !== null &&
      this.comparePriceMin > this.priceMin &&
      this.productType.includes('廃番')
    )
  }

  get isSoldout() {
    return this.productStatus === 'soldout'
  }

  get isBackstock() {
    return this.productStatus === 'backstock'
  }

  get productStatus() {
    if (
      this.productType.includes('予約品') &&
      !this.tags.includes('out_of_stock')
    )
      return 'presale'

    if (
      this.available === false ||
      this.tags.includes('out_of_stock') ||
      this.stock <= 0
    )
      if (this.tags.includes('not-bis')) return 'soldout'
      else if (this.productType.includes('オーダーカーテン'))
        return 'unavailable'
      else return 'backstock'
    return 'available'
  }

  get priceText() {
    return this.productType.includes('オーダーカーテン')
      ? `${numberWithCommas(this.priceMin)}~`
      : numberWithCommas(this.price)
  }

  get comparePriceText() {
    return this.productType.includes('オーダーカーテン')
      ? `${numberWithCommas(this.comparePriceMin)}~`
      : numberWithCommas(this.comparePrice)
  }

  get plainTitle() {
    const tempDivElement = document.createElement('div')
    tempDivElement.innerHTML = this.title
    return tempDivElement.textContent || tempDivElement.innerText
  }

  get enhancedTitle() {
    return `${this.text1}${this.text2}${this.title}`
  }

  get zetaItemUnit() {
    return this.itemGroupId ? 'item_group_id' : 'code'
  }

  get zetaItemId() {
    return this.itemGroupId || this.handle.toString()
  }
}
